// DO NOT PUT SECRETS IN HERE!!!
const staging = {
  flags: {
    enablePseudoLocale: true,
  },
  RSS_LINKS_URL: "https://stg-cal.read.ai",
  INTERNAL_API_URL: "https://app-backend.infra.read.ai",
  FRONTEND_URL: "https://stg-app.read.ai",
  api: {
    HOST: "https://stg-api.read.ai",
  },
  apps: {
    meet: {
      CLIENT_ID:
        "307358853148-pfp68q0vqgukrgevecaa3k4e34742hoq.apps.googleusercontent.com",
    },
  },
  tracking: {
    GOOGLE_ID: "G-JQN958QXJF",
    MIXPANEL_VERBOSE_LOG: true,
    MIXPANEL_ID: "d34b18861b5c0ad5ffe89d8d307bdcdc",
    STATSIG_KEY: "client-ntzxY8eFoeabjvRLm0AvTF1uFPkb9X7Qu8w1EmeRKH1",
    USERPILOT_ID: "STG-NX-91d10b5e",
  },
};

export type Config = typeof staging;

export default staging;
